import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  output,
  untracked,
  viewChild,
} from '@angular/core';
import {
  HintMessageFetcher,
  NotificationHintComponent,
} from 'src/app/ui/feedback/notification-hint/notification-hint.component';
import { ButtonComponent } from '../../../../ui/buttons/button/button.component';
import { CountdownPillComponent } from '../../../../ui/pills/countdown-pill/countdown-pill.component';

@Component({
  selector: 'app-loading-game-controls-view',
  templateUrl: './loading-game-controls-view.component.html',
  styleUrls: ['./loading-game-controls-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CountdownPillComponent, NotificationHintComponent, ButtonComponent],
})
export class LoadingGameControlsViewComponent {
  // The hint sits in an @else branch, so each time a new instance renders it is started once.
  private readonly hintMessage = viewChild<NotificationHintComponent>('hintMessage');

  readonly hasUnfinishedRoom = input.required<boolean>();
  readonly unfinishedTimeRemaining = input.required<string>();
  // The hint's own fetch contract, passed through so the container keeps the activity feed.
  readonly fetchHints = input.required<HintMessageFetcher>();
  readonly playButtonLabel = input.required<string>();
  readonly playButtonClickedEvent = output<void>();

  constructor() {
    effect(() => {
      const hintMessage = this.hintMessage();
      if (hintMessage) {
        untracked(() => hintMessage.start());
      }
    });
  }

  playButtonClicked(): void {
    this.playButtonClickedEvent.emit();
  }
}
